<template>
    <div class="dropdown" :class="{active: isOpen}" v-click-outside="onClickOutside">
        <div class="selected"  @click="toggle">
            <svg width="13" height="3" viewBox="0 0 13 3" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin: 0;">
                <rect width="13" height="3" fill="#EEEEEE"/>
                <rect width="3" height="3" rx="1.5" fill="#252525"/>
                <rect x="5" width="3" height="3" rx="1.5" fill="#252525"/>
                <rect x="10" width="3" height="3" rx="1.5" fill="#252525"/>
            </svg>
        </div>
        <div class="options" :class="{right: isMobile}" v-show="isOpen">
            <div class="option" @click="$emit('edit'); hide()">
                <icon-edit/>
                Редагувати
            </div>
            <div class="option" @click="$emit('remove'); hide()">
                <icon-remove class="text-danger"/>
                Видалити
            </div>
        </div>
    </div>
</template>

<script>

import IconEdit from '../../icons/IconEdit.vue';
import IconRemove from '../../icons/IconRemove.vue';

Vue.directive("click-outside", {
    bind(el, binding, vnode) {
        el.clickOutsideEvent = (event) => {
            if (!(el === event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    },
});
export default {
    name: "TestCommentOptions",
    components: {IconRemove, IconEdit},
    emits: ['setSelection'],
    data: function() {
        return {
            isOpen: false,
            isMobile: window.innerWidth < 991
        }
    },
    methods: {
        toggle() {
            this.isOpen = !this.isOpen;
        },
        hide () {
            this.isOpen = false;
        },
        onClickOutside () {
            this.hide()
        },
    }
}
</script>
<style lang="scss" scoped>
.dropdown {
    .selected {
        padding: 10px;
    }

    .options {
        &.right {
            right: 0;
            left: auto;
        }
        .option {
            justify-content: flex-start;
        }
    }
}
</style>
